"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.PulseStyle = exports.SKELETONPULSE = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _themeContants = require("../../constants/themeContants");

var _theming = require("../../theming");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SkeletonPulse = function SkeletonPulse(_ref) {
  var className = _ref.className,
      restProps = _objectWithoutProperties(_ref, ["className"]);

  return _react["default"].createElement(PulseStyle, _extends({
    className: className
  }, restProps));
};

SkeletonPulse.themeProps = {
  pulse: {
    name: "pulse",
    description: "The pulse animation",
    type: _themeContants.themePropTypes.style
  }
};
var SKELETONPULSE = "skeletonpulse";
exports.SKELETONPULSE = SKELETONPULSE;
var pulseAnimation = (0, _styledComponents.keyframes)(["0%{background-position:0% 0%;}100%{background-position:-135% 0%;}"]);

var PulseStyle = _styledComponents["default"].div.withConfig({
  displayName: "SkeletonPulse__PulseStyle",
  componentId: "h9haz8-0"
})(["display:inline-block;height:100%;width:100%;background-image:linear-gradient( -90deg,#f0f0f0 0%,#f8f8f8 50%,#f0f0f0 100% );background-size:400% 400%;animation:", " 1.2s ease-in-out infinite;", ";"], pulseAnimation, (0, _theming.applyVariants)(SkeletonPulse.themeProps.pulse));

exports.PulseStyle = PulseStyle;
SkeletonPulse.defaultProps = {
  className: null
};
SkeletonPulse.propTypes = {
  className: _propTypes["default"].string
};
var _default = SkeletonPulse;
exports["default"] = _default;